import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import serverVars from 'server-vars';
import tracking from 'dibs-tracking';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';
import { getEnvironment } from '../../relayModernEnvironment';
import CartRenderer from '../../cart/CartRenderer';

initializeDBL().then(({ store }) => {
    ReactDOM.render(
        <Provider store={store}>
            <IntlProvider
                locale={serverVars.get('localeDataKey')}
                messages={serverVars.get('messages')}
            >
                <CartRenderer relayEnvironment={getEnvironment()} />
            </IntlProvider>
        </Provider>,
        document.getElementById('js-root')
    );
    tracking.trackPageview();
});
